export const constant = {
	selector: {
		stream: 'data-m-checkbox-stream',
	},
}
